import { useClient } from '../supabase/client'

import { FunctionsHttpError } from '@supabase/supabase-js'
import { useMutation } from '@tanstack/vue-query'
import type { GetSignedFileUrlReq, GetSignedFileUrlRes } from '@xleddyl/types'

type Props = GetSignedFileUrlReq

export const useGetSignedFileUrl = () => {
   const client = useClient()

   return useMutation({
      mutationFn: async (props: Props) => {
         const { data, error } = await client.functions.invoke('get_signed_file_url', {
            body: props satisfies GetSignedFileUrlReq,
         })

         if (error) {
            if (error instanceof FunctionsHttpError) {
               const payload = await error.context.json().catch(() => null)
               const key = payload?.error
               throw new Error(typeof key === 'string' ? key : 'error.api.generic')
            }
            throw new Error(error.message)
         }

         return data as GetSignedFileUrlRes
      },
   })
}
